/* eslint-disable react/jsx-no-literals */
import React from 'react'

function TruckLogoMaintenaceIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="472.324"
      height="234.805"
      viewBox="0 0 472.324 234.805"
      {...props}
    >
      <g
        id="Group_412"
        data-name="Group 412"
        transform="translate(-323.011 -580.891)"
      >
        <path
          id="Path_378"
          data-name="Path 378"
          d="M387.065,580.891v13.517c0,.226-.016.449-.034.672a8.78,8.78,0,0,1-.4,1.844h.038a8.228,8.228,0,0,1-7.831,5.711h-45.25a8.227,8.227,0,1,0,0,16.455h45.25a8.227,8.227,0,0,1,8.226,8.227v22.23a8.228,8.228,0,0,1-8.226,8.228H359.445a8.227,8.227,0,0,0-.005,16.453H622.671V661.671l39.687,26.01-39.687,26.011V701.135H380.818a8.2,8.2,0,0,1-1.979.25h-47.6a8.227,8.227,0,1,0,0,16.454h47.6a8.227,8.227,0,0,1,8.226,8.228v8.589H669.219V580.891Z"
          transform="translate(0 0)"
          fill="#008bd0"
        />
        <path
          id="s"
          d="M412.558,830.164a6.541,6.541,0,0,0,2.247,4.871,8.179,8.179,0,0,0,5.438,2h44.978a43.923,43.923,0,0,1,3.362-16.954H412.558Z"
          transform="translate(-22.144 -59.149)"
          fill="#00668f"
        />
        <path
          id="s-2"
          data-name="s"
          d="M598.956,837.035H718.862a43.978,43.978,0,0,1,3.362-16.954H595.6A43.978,43.978,0,0,1,598.956,837.035Z"
          transform="translate(-67.408 -59.149)"
          fill="#00668f"
        />
        <path
          id="s-3"
          data-name="s"
          d="M560.229,809.086c-.593-.84-1.185-1.679-1.829-2.471a37.815,37.815,0,0,0-59.087,0c-.644.792-1.235,1.631-1.829,2.471a34.7,34.7,0,0,0-2.4,4.151,37.216,37.216,0,0,0-4.028,16.954,37.8,37.8,0,1,0,75.6,0,37.18,37.18,0,0,0-4.031-16.954A34.262,34.262,0,0,0,560.229,809.086ZM528.87,849.763a19.556,19.556,0,0,1-9.739-36.526,19.411,19.411,0,0,1,19.473,0,19.556,19.556,0,0,1-9.735,36.526Z"
          transform="translate(-41.556 -52.305)"
          fill="#00668f"
        />
        <path
          id="s-4"
          data-name="s"
          d="M805.716,792.4a37.823,37.823,0,0,0-7.34.717,36.4,36.4,0,0,0-8.748,2.891,37.764,37.764,0,1,0,16.088-3.609Zm0,57.359a19.572,19.572,0,1,1,19.572-19.572A19.569,19.569,0,0,1,805.716,849.763Z"
          transform="translate(-110.024 -52.305)"
          fill="#00668f"
        />
        <g
          id="Group_410"
          data-name="Group 410"
          transform="translate(425.038 596.924)"
        >
          <g id="Group_407" data-name="Group 407" transform="translate(0 0)">
            <g id="Group_405" data-name="Group 405">
              <path
                id="Path_379"
                data-name="Path 379"
                d="M517.246,607.736l-4.845-5.545H493.867c-7.979,0-35.31,7.136-35.31,34.819,0,20.523,18.346,34,35.286,34,10.482,0,15.257-2.622,15.257-2.622v-6.271s-4.865,3.745-15.161,3.745c-8.8,0-29.764-8.049-29.764-29.3,0-22.651,22.65-28.829,30.792-28.829Z"
                transform="translate(-458.557 -602.191)"
                fill="#fff"
              />
              <path
                id="Path_380"
                data-name="Path 380"
                d="M525.821,616.839l-4.836-5.376s-19.1-.015-22.781-.015a32.781,32.781,0,0,0-22.645,9.559c-5.1,5.2-6.871,10.314-6.871,18.584,0,16.484,15.761,26.722,28.242,26.722,10,0,14.623-4.07,14.623-4.07v-5.908a27.066,27.066,0,0,1-14.813,4.419,23.089,23.089,0,0,1-16.7-7.766c-3.915-4.334-5.8-8.126-5.8-13.927a20.784,20.784,0,0,1,8.7-17.616c5.2-3.991,11.428-4.637,20.753-4.637C505.422,616.807,511.916,616.838,525.821,616.839Z"
                transform="translate(-461.063 -604.48)"
                fill="#fff"
              />
              <path
                id="Path_381"
                data-name="Path 381"
                d="M534.82,626.559l-4.835-5.4s-24.037-.01-27.1-.01c-8.156,0-11.152.356-16.581,4.193-4.208,2.975-7.787,8.566-7.787,16.236,0,12.04,11.174,19.891,21.545,19.891a21.094,21.094,0,0,0,13.917-5.082v-8.938s-4.183,8.594-14.1,8.594a17.958,17.958,0,0,1-11.606-5.148,12.7,12.7,0,0,1-3.931-9.109c0-4.9,1.213-9.526,6.047-12.868,3.155-2.182,9.307-2.358,17.062-2.358Z"
                transform="translate(-463.493 -606.879)"
                fill="#fff"
              />
              <path
                id="Path_382"
                data-name="Path 382"
                d="M524.126,653.091v-5.067h-4.542Z"
                transform="translate(-473.648 -613.525)"
                fill="#fff"
              />
              <path
                id="Path_383"
                data-name="Path 383"
                d="M515.867,643.7l-4.449-5.2H529.35v41.373h-5.333V643.748Z"
                transform="translate(-471.629 -611.171)"
                fill="#fff"
              />
              <rect
                id="Rectangle_463"
                data-name="Rectangle 463"
                width="5.381"
                height="41.369"
                transform="translate(59.381 27.338)"
                fill="#fff"
              />
              <rect
                id="Rectangle_464"
                data-name="Rectangle 464"
                width="5.382"
                height="41.383"
                transform="translate(66.574 27.323)"
                fill="#fff"
              />
            </g>
            <g id="Group_406" data-name="Group 406">
              <path
                id="Path_384"
                data-name="Path 384"
                d="M517.246,607.736l-4.845-5.545H493.867c-7.979,0-35.31,7.136-35.31,34.819,0,20.523,18.346,34,35.286,34,10.482,0,15.257-2.622,15.257-2.622v-6.271s-4.865,3.745-15.161,3.745c-8.8,0-29.764-8.049-29.764-29.3,0-22.651,22.65-28.829,30.792-28.829Z"
                transform="translate(-458.557 -602.191)"
                fill="#fff"
              />
              <path
                id="Path_385"
                data-name="Path 385"
                d="M525.821,616.839l-4.836-5.376s-19.1-.015-22.781-.015a32.781,32.781,0,0,0-22.645,9.559c-5.1,5.2-6.871,10.314-6.871,18.584,0,16.484,15.761,26.722,28.242,26.722,10,0,14.623-4.07,14.623-4.07v-5.908a27.066,27.066,0,0,1-14.813,4.419,23.089,23.089,0,0,1-16.7-7.766c-3.915-4.334-5.8-8.126-5.8-13.927a20.784,20.784,0,0,1,8.7-17.616c5.2-3.991,11.428-4.637,20.753-4.637C505.422,616.807,511.916,616.838,525.821,616.839Z"
                transform="translate(-461.063 -604.48)"
                fill="#fff"
              />
              <path
                id="Path_386"
                data-name="Path 386"
                d="M534.82,626.559l-4.835-5.4s-24.037-.01-27.1-.01c-8.156,0-11.152.356-16.581,4.193-4.208,2.975-7.787,8.566-7.787,16.236,0,12.04,11.174,19.891,21.545,19.891a21.094,21.094,0,0,0,13.917-5.082v-8.938s-4.183,8.594-14.1,8.594a17.958,17.958,0,0,1-11.606-5.148,12.7,12.7,0,0,1-3.931-9.109c0-4.9,1.213-9.526,6.047-12.868,3.155-2.182,9.307-2.358,17.062-2.358Z"
                transform="translate(-463.493 -606.879)"
                fill="#fff"
              />
              <path
                id="Path_387"
                data-name="Path 387"
                d="M524.126,653.091v-5.067h-4.542Z"
                transform="translate(-473.648 -613.525)"
                fill="#fff"
              />
              <path
                id="Path_388"
                data-name="Path 388"
                d="M515.867,643.7l-4.449-5.2H529.35v41.373h-5.333V643.748Z"
                transform="translate(-471.629 -611.171)"
                fill="#fff"
              />
              <rect
                id="Rectangle_465"
                data-name="Rectangle 465"
                width="5.381"
                height="41.369"
                transform="translate(59.381 27.338)"
                fill="#fff"
              />
              <rect
                id="Rectangle_466"
                data-name="Rectangle 466"
                width="5.382"
                height="41.383"
                transform="translate(66.574 27.323)"
                fill="#fff"
              />
            </g>
          </g>
          <g
            id="Group_408"
            data-name="Group 408"
            transform="translate(89.573 26.61)"
          >
            <path
              id="Path_389"
              data-name="Path 389"
              d="M604.377,662.117h-2.949l-.7-3.112a11.84,11.84,0,0,1-9.107,3.785c-10.111,0-14.06-5.894-14.06-12.627s4.181-12.62,13.925-12.62c7.27,0,11.921,3.684,12.454,8.372h-5.422c-.906-3.249-3.917-4.62-7.163-4.62-6.2,0-8.573,3.782-8.573,9.04,0,6.36,4.082,8.7,8.3,8.7,5.123,0,7.468-2.343,8.268-6.293h-6.761v-3.751h11.787Z"
              transform="translate(-577.557 -637.543)"
              fill="#fff"
            />
            <path
              id="Path_390"
              data-name="Path 390"
              d="M622.99,656.441c.1,1.977,1.438,5.025,6.025,5.025,3.051,0,4.386-1.072,5.3-2.546h5.018c-1,1.977-3.415,5.894-10.182,5.894-8,0-10.98-4.657-10.98-9.376,0-5.926,4.387-9.708,10.679-9.708,7.865,0,10.886,4.853,10.886,10.044v.667Zm11.921-2.945c-.57-3.55-3.715-4.62-5.992-4.62a5.736,5.736,0,0,0-5.929,4.62Z"
              transform="translate(-587.6 -639.568)"
              fill="#fff"
            />
            <path
              id="Path_391"
              data-name="Path 391"
              d="M651.74,648.161h-3.682v-3.348h3.682v-5.49h4.627v5.49h4.814v3.348h-4.814v8.1c0,2.042.095,3.146,1.666,3.146,1.139,0,2.214-.032,3.323-.068v3.349a23.22,23.22,0,0,1-3.55.269c-5.63,0-6.066-2.008-6.066-5.356Z"
              transform="translate(-594.991 -637.983)"
              fill="#fff"
            />
            <path
              id="Path_392"
              data-name="Path 392"
              d="M667.634,661.013l11.953-10.846H668.266v-3.549h17.913v3.147l-12.188,11.047h12.623v3.55h-18.98Z"
              transform="translate(-599.832 -639.787)"
              fill="#fff"
            />
          </g>
          <g
            id="Group_409"
            data-name="Group 409"
            transform="translate(89.91 55.727)"
          >
            <path
              id="Path_393"
              data-name="Path 393"
              d="M578.006,676.226h1.24v5.652h7.73v-5.652h1.241v13.017h-1.241v-6.308h-7.73v6.308h-1.24Z"
              transform="translate(-578.006 -676.226)"
              fill="#fff"
            />
            <path
              id="Path_394"
              data-name="Path 394"
              d="M595.894,685.946c.018,1.678.893,3.7,3.1,3.7a2.868,2.868,0,0,0,2.954-2.406h1.147a3.841,3.841,0,0,1-4.1,3.373c-2.99,0-4.248-2.3-4.248-4.977,0-2.48,1.257-4.977,4.248-4.977,3.026,0,4.229,2.644,4.138,5.287Zm6.089-.967c-.056-1.731-1.131-3.354-2.99-3.354-1.879,0-2.918,1.642-3.1,3.354Z"
              transform="translate(-582.146 -677.322)"
              fill="#fff"
            />
            <path
              id="Path_395"
              data-name="Path 395"
              d="M608.274,683.813c.11-2.206,1.66-3.154,3.811-3.154,1.659,0,3.465.511,3.465,3.026v5a.611.611,0,0,0,.674.692,1.054,1.054,0,0,0,.364-.074v.968a3.172,3.172,0,0,1-.746.072c-1.167,0-1.35-.656-1.35-1.641h-.036a3.586,3.586,0,0,1-3.428,1.914c-1.732,0-3.155-.856-3.155-2.753,0-2.643,2.571-2.734,5.051-3.026.948-.109,1.476-.236,1.476-1.277,0-1.551-1.112-1.932-2.461-1.932-1.421,0-2.478.657-2.515,2.188ZM614.4,685.2h-.036c-.146.273-.656.364-.966.419-1.952.346-4.375.328-4.375,2.169a1.958,1.958,0,0,0,2.1,1.859,3.024,3.024,0,0,0,3.281-2.954Z"
              transform="translate(-585.392 -677.322)"
              fill="#fff"
            />
            <path
              id="Path_396"
              data-name="Path 396"
              d="M621.754,676.226H622.9v13.017h-1.149Z"
              transform="translate(-588.824 -676.226)"
              fill="#fff"
            />
            <path
              id="Path_397"
              data-name="Path 397"
              d="M628.322,680.094h1.914v.966h-1.914V687.4c0,.748.11,1.185.929,1.24a8.79,8.79,0,0,0,.985-.055v.986c-.346,0-.674.035-1.02.035-1.532,0-2.061-.51-2.042-2.114V681.06h-1.642v-.966h1.642v-2.826h1.148Z"
              transform="translate(-589.759 -676.484)"
              fill="#fff"
            />
            <path
              id="Path_398"
              data-name="Path 398"
              d="M634.569,676.226h1.148v5.233h.036a3.19,3.19,0,0,1,3.008-1.9c2.643,0,3.445,1.385,3.445,3.628v6.053h-1.148v-5.871c0-1.622-.529-2.844-2.388-2.844a2.969,2.969,0,0,0-2.953,3.227v5.488h-1.148Z"
              transform="translate(-591.993 -676.226)"
              fill="#fff"
            />
            <path
              id="Path_399"
              data-name="Path 399"
              d="M654.686,683.886a2.558,2.558,0,0,0-2.663-2.261c-2.205,0-3.3,2.006-3.3,4.011s1.093,4.01,3.3,4.01a2.8,2.8,0,0,0,2.735-2.68h1.149a3.83,3.83,0,0,1-3.884,3.646c-2.88,0-4.448-2.278-4.448-4.977s1.568-4.977,4.448-4.977a3.517,3.517,0,0,1,3.81,3.227Z"
              transform="translate(-595.21 -677.322)"
              fill="#fff"
            />
            <path
              id="Path_400"
              data-name="Path 400"
              d="M661.105,683.813c.109-2.206,1.658-3.154,3.809-3.154,1.66,0,3.465.511,3.465,3.026v5a.612.612,0,0,0,.674.692,1.056,1.056,0,0,0,.364-.074v.968a3.172,3.172,0,0,1-.747.072c-1.167,0-1.35-.656-1.35-1.641h-.035a3.586,3.586,0,0,1-3.427,1.914c-1.733,0-3.155-.856-3.155-2.753,0-2.643,2.571-2.734,5.05-3.025.948-.11,1.476-.237,1.476-1.277,0-1.551-1.111-1.933-2.461-1.933-1.422,0-2.479.657-2.515,2.188Zm6.125,1.386h-.037c-.145.273-.655.364-.965.419-1.952.346-4.376.329-4.376,2.169a1.959,1.959,0,0,0,2.1,1.859,3.023,3.023,0,0,0,3.28-2.954Z"
              transform="translate(-598.456 -677.322)"
              fill="#fff"
            />
            <path
              id="Path_401"
              data-name="Path 401"
              d="M674.56,680.979h1.057v2.206h.038a3.473,3.473,0,0,1,3.554-2.335V682a3.241,3.241,0,0,0-3.5,3.372v5.015H674.56Z"
              transform="translate(-601.883 -677.369)"
              fill="#fff"
            />
            <path
              id="Path_402"
              data-name="Path 402"
              d="M682.883,685.947c.018,1.677.893,3.7,3.1,3.7a2.865,2.865,0,0,0,2.954-2.406h1.149a3.843,3.843,0,0,1-4.1,3.373c-2.988,0-4.246-2.3-4.246-4.977,0-2.48,1.258-4.977,4.246-4.977,3.027,0,4.23,2.644,4.14,5.288Zm6.088-.968c-.054-1.731-1.13-3.354-2.991-3.354-1.877,0-2.916,1.642-3.1,3.354Z"
              transform="translate(-603.657 -677.322)"
              fill="#fff"
            />
          </g>
          <rect
            id="Rectangle_467"
            data-name="Rectangle 467"
            width="0.183"
            height="41.694"
            transform="translate(79.823 27.323)"
            fill="#fff"
          />
        </g>
        <path
          id="Path_403"
          data-name="Path 403"
          d="M897,644.275c-12.232-12.231-28.2-22.76-43.494-25.034-15.272-2.273-45.126-2.421-45.126-2.421V743.153a42.432,42.432,0,0,1,7.339-.618,44.255,44.255,0,0,1,44.238,44.235h37.069a18.354,18.354,0,0,0,18.337-18.313v-79.87A62.485,62.485,0,0,0,897,644.275Zm5.488,46.411H823.924V634.713s21.92.1,33.14,1.779,22.956,9.414,31.929,18.385a45.872,45.872,0,0,1,13.493,32.547Z"
          transform="translate(-120.026 -8.885)"
          fill="#00668f"
        />
        <g
          id="Group_411"
          data-name="Group 411"
          transform="translate(392.769 682.51)"
        >
          <path
            id="Path_404"
            data-name="Path 404"
            d="M418.088,723.765l-1.05,3.182h-1.351l3.437-10.115H420.7l3.452,10.115h-1.395l-1.08-3.182Zm3.316-1.019-.99-2.913c-.226-.659-.376-1.261-.526-1.846h-.029c-.151.6-.315,1.216-.512,1.831l-.99,2.927Z"
            transform="translate(-415.687 -716.127)"
            fill="#00668f"
          />
          <path
            id="Path_405"
            data-name="Path 405"
            d="M439.185,716.114V724.9c0,.645.014,1.38.06,1.875H438.06L438,725.509h-.029a2.686,2.686,0,0,1-2.476,1.426c-1.756,0-3.107-1.484-3.107-3.692-.014-2.416,1.487-3.9,3.258-3.9a2.427,2.427,0,0,1,2.19,1.111h.031v-4.337Zm-1.32,6.348a2.409,2.409,0,0,0-.06-.555,1.946,1.946,0,0,0-1.907-1.531c-1.365,0-2.176,1.2-2.176,2.807,0,1.472.721,2.687,2.147,2.687a1.986,1.986,0,0,0,1.936-1.576,2.361,2.361,0,0,0,.06-.57Z"
            transform="translate(-419.816 -715.949)"
            fill="#00668f"
          />
          <path
            id="Path_406"
            data-name="Path 406"
            d="M445.753,717.637a.818.818,0,0,1-1.636,0,.8.8,0,0,1,.825-.827A.785.785,0,0,1,445.753,717.637Zm-1.471,9.305v-7.264h1.32v7.264Z"
            transform="translate(-422.717 -716.122)"
            fill="#00668f"
          />
          <path
            id="Path_407"
            data-name="Path 407"
            d="M449.218,720.62l1.426,4.082a18.7,18.7,0,0,1,.585,1.863h.046c.165-.6.373-1.2.613-1.863l1.412-4.082h1.38l-2.851,7.264h-1.261l-2.762-7.264Z"
            transform="translate(-423.63 -717.063)"
            fill="#00668f"
          />
          <path
            id="Path_408"
            data-name="Path 408"
            d="M460.017,717.637a.818.818,0,0,1-1.636,0,.8.8,0,0,1,.825-.827A.785.785,0,0,1,460.017,717.637Zm-1.471,9.305v-7.264h1.32v7.264Z"
            transform="translate(-426.245 -716.122)"
            fill="#00668f"
          />
          <path
            id="Path_409"
            data-name="Path 409"
            d="M462.919,726.479a3.467,3.467,0,0,0,1.741.526c.961,0,1.412-.48,1.412-1.082,0-.631-.376-.975-1.351-1.335-1.305-.465-1.921-1.186-1.921-2.056a2.241,2.241,0,0,1,2.506-2.132,3.622,3.622,0,0,1,1.787.452l-.332.961a2.821,2.821,0,0,0-1.484-.42c-.781,0-1.216.449-1.216.99,0,.6.434.871,1.38,1.23,1.261.48,1.907,1.111,1.907,2.193,0,1.276-.992,2.176-2.717,2.176a4.167,4.167,0,0,1-2.042-.5Z"
            transform="translate(-427.285 -717.009)"
            fill="#00668f"
          />
          <path
            id="Path_410"
            data-name="Path 410"
            d="M472.585,717.637a.818.818,0,0,1-1.635,0,.8.8,0,0,1,.825-.827A.784.784,0,0,1,472.585,717.637Zm-1.47,9.305v-7.264h1.32v7.264Z"
            transform="translate(-429.353 -716.122)"
            fill="#00668f"
          />
          <path
            id="Path_411"
            data-name="Path 411"
            d="M482.239,724.138a3.55,3.55,0,0,1-3.617,3.857,3.454,3.454,0,0,1-3.483-3.738,3.547,3.547,0,0,1,3.6-3.857A3.441,3.441,0,0,1,482.239,724.138Zm-5.764.075c0,1.591.915,2.792,2.205,2.792,1.262,0,2.207-1.186,2.207-2.823,0-1.231-.616-2.79-2.176-2.79S476.475,722.833,476.475,724.213Z"
            transform="translate(-430.389 -717.009)"
            fill="#00668f"
          />
          <path
            id="Path_412"
            data-name="Path 412"
            d="M486.77,722.532c0-.752-.017-1.366-.061-1.967h1.172l.075,1.2h.029a2.674,2.674,0,0,1,2.4-1.366c1,0,2.566.6,2.566,3.093v4.337h-1.322v-4.187c0-1.172-.434-2.147-1.681-2.147a1.878,1.878,0,0,0-1.77,1.351,1.931,1.931,0,0,0-.09.613v4.369H486.77Z"
            transform="translate(-433.25 -717.009)"
            fill="#00668f"
          />
          <path
            id="Path_413"
            data-name="Path 413"
            d="M508.495,724.138a3.55,3.55,0,0,1-3.617,3.857,3.454,3.454,0,0,1-3.483-3.738A3.547,3.547,0,0,1,505,720.4,3.441,3.441,0,0,1,508.495,724.138Zm-5.763.075c0,1.591.914,2.792,2.205,2.792,1.261,0,2.207-1.186,2.207-2.823,0-1.231-.616-2.79-2.176-2.79S502.731,722.833,502.731,724.213Z"
            transform="translate(-436.882 -717.009)"
            fill="#00668f"
          />
          <path
            id="Path_414"
            data-name="Path 414"
            d="M512.888,726.716v-6.258h-1.019v-1.006h1.019v-.345a3.427,3.427,0,0,1,.841-2.537,2.525,2.525,0,0,1,1.771-.674,3.072,3.072,0,0,1,1.125.209l-.18,1.021a1.986,1.986,0,0,0-.842-.165c-1.125,0-1.409.99-1.409,2.1v.391h1.756v1.006H514.2v6.258Z"
            transform="translate(-439.472 -715.895)"
            fill="#00668f"
          />
          <path
            id="Path_415"
            data-name="Path 415"
            d="M530.662,726.462a9.39,9.39,0,0,1-3.1.555,4.748,4.748,0,0,1-5.194-5.1c.015-3.017,2.086-5.225,5.477-5.225a6.276,6.276,0,0,1,2.522.466l-.315,1.065a5.242,5.242,0,0,0-2.236-.434,3.783,3.783,0,0,0-4.068,4.068c0,2.566,1.545,4.082,3.9,4.082a4.252,4.252,0,0,0,1.741-.271v-3.015h-2.056V721.6h3.331Z"
            transform="translate(-442.067 -716.092)"
            fill="#00668f"
          />
          <path
            id="Path_416"
            data-name="Path 416"
            d="M536.651,724.439a2.327,2.327,0,0,0,2.491,2.52,4.764,4.764,0,0,0,2.011-.376l.225.946a5.872,5.872,0,0,1-2.416.451,3.373,3.373,0,0,1-3.572-3.663c0-2.19,1.29-3.918,3.408-3.918,2.37,0,3,2.087,3,3.423a5.249,5.249,0,0,1-.044.616Zm3.872-.946a1.881,1.881,0,0,0-1.831-2.147,2.188,2.188,0,0,0-2.026,2.147Z"
            transform="translate(-445.288 -717.009)"
            fill="#00668f"
          />
          <path
            id="Path_417"
            data-name="Path 417"
            d="M547.4,717.848v2.087h1.889v1.006H547.4v3.917c0,.9.254,1.41.99,1.41a2.93,2.93,0,0,0,.766-.09l.059.992a3.24,3.24,0,0,1-1.17.18,1.835,1.835,0,0,1-1.426-.555,2.692,2.692,0,0,1-.511-1.892v-3.961h-1.126v-1.006h1.126v-1.74Z"
            transform="translate(-447.661 -716.378)"
            fill="#00668f"
          />
          <path
            id="Path_418"
            data-name="Path 418"
            d="M551.588,727.118l3.286-4.277c.315-.39.616-.735.946-1.125v-.029h-3.932V720.62h5.538l-.014.827-3.241,4.216c-.3.406-.6.766-.931,1.14v.032h4.247v1.05h-5.9Z"
            transform="translate(-449.294 -717.063)"
            fill="#00668f"
          />
          <path
            id="Path_419"
            data-name="Path 419"
            d="M565.513,716.942a12.767,12.767,0,0,1,2.387-.209,4.186,4.186,0,0,1,2.777.735,2.122,2.122,0,0,1,.84,1.786,2.4,2.4,0,0,1-1.71,2.222v.029a2.607,2.607,0,0,1,2.086,2.537,2.723,2.723,0,0,1-.856,2.026,5.081,5.081,0,0,1-3.5.946,15.561,15.561,0,0,1-2.028-.119Zm1.307,4.143H568c1.382,0,2.192-.72,2.192-1.7,0-1.186-.9-1.652-2.221-1.652a5.619,5.619,0,0,0-1.155.09Zm0,4.849a7.158,7.158,0,0,0,1.094.059c1.351,0,2.6-.5,2.6-1.965,0-1.38-1.185-1.953-2.612-1.953h-1.08Z"
            transform="translate(-452.737 -716.102)"
            fill="#00668f"
          />
          <path
            id="Path_420"
            data-name="Path 420"
            d="M576.248,722.833c0-.856-.015-1.591-.061-2.267h1.155l.045,1.426h.061a2.18,2.18,0,0,1,2.011-1.591,1.375,1.375,0,0,1,.374.046v1.245a2.014,2.014,0,0,0-.449-.044,1.852,1.852,0,0,0-1.771,1.7,3.64,3.64,0,0,0-.06.616v3.872h-1.305Z"
            transform="translate(-455.377 -717.009)"
            fill="#00668f"
          />
          <path
            id="Path_421"
            data-name="Path 421"
            d="M588.992,724.138a3.549,3.549,0,0,1-3.616,3.857,3.454,3.454,0,0,1-3.484-3.738,3.547,3.547,0,0,1,3.6-3.857A3.441,3.441,0,0,1,588.992,724.138Zm-5.763.075c0,1.591.915,2.792,2.2,2.792,1.262,0,2.208-1.186,2.208-2.823,0-1.231-.617-2.79-2.176-2.79S583.23,722.833,583.23,724.213Z"
            transform="translate(-456.788 -717.009)"
            fill="#00668f"
          />
          <path
            id="Path_422"
            data-name="Path 422"
            d="M593.195,726.479a3.467,3.467,0,0,0,1.742.526c.96,0,1.411-.48,1.411-1.082,0-.631-.376-.975-1.351-1.335-1.305-.465-1.921-1.186-1.921-2.056a2.241,2.241,0,0,1,2.506-2.132,3.626,3.626,0,0,1,1.787.452l-.331.961a2.827,2.827,0,0,0-1.485-.42c-.781,0-1.216.449-1.216.99,0,.6.434.871,1.381,1.23,1.261.48,1.907,1.111,1.907,2.193,0,1.276-.992,2.176-2.717,2.176a4.163,4.163,0,0,1-2.042-.5Z"
            transform="translate(-459.501 -717.009)"
            fill="#00668f"
          />
          <path
            id="Path_423"
            data-name="Path 423"
            d="M600.806,728.923a.887.887,0,0,1,.9-.946.947.947,0,1,1-.9.946Z"
            transform="translate(-461.465 -718.883)"
            fill="#00668f"
          />
          <path
            id="Path_424"
            data-name="Path 424"
            d="M609.644,716.927a15.19,15.19,0,0,1,2.508-.194,4.153,4.153,0,0,1,2.835.839,2.72,2.72,0,0,1,.886,2.117,2.974,2.974,0,0,1-.781,2.161A4.185,4.185,0,0,1,612,722.96a4.465,4.465,0,0,1-1.05-.09v4.053h-1.307Zm1.307,4.878a4.366,4.366,0,0,0,1.079.1c1.577,0,2.537-.764,2.537-2.161,0-1.335-.946-1.98-2.387-1.98a5.406,5.406,0,0,0-1.23.1Z"
            transform="translate(-463.651 -716.102)"
            fill="#00668f"
          />
          <path
            id="Path_425"
            data-name="Path 425"
            d="M620.1,716.114h1.32v4.534h.031a2.44,2.44,0,0,1,.944-.931,2.716,2.716,0,0,1,1.351-.376c.976,0,2.537.6,2.537,3.107v4.323h-1.322V722.6c0-1.171-.434-2.161-1.681-2.161a1.9,1.9,0,0,0-1.771,1.32,1.6,1.6,0,0,0-.089.631v4.383H620.1Z"
            transform="translate(-466.236 -715.949)"
            fill="#00668f"
          />
          <path
            id="Path_426"
            data-name="Path 426"
            d="M632.587,717.637a.818.818,0,0,1-1.636,0,.8.8,0,0,1,.825-.827A.785.785,0,0,1,632.587,717.637Zm-1.47,9.305v-7.264h1.319v7.264Z"
            transform="translate(-468.919 -716.122)"
            fill="#00668f"
          />
          <path
            id="Path_427"
            data-name="Path 427"
            d="M635.839,716.114h1.32V726.77h-1.32Z"
            transform="translate(-470.128 -715.949)"
            fill="#00668f"
          />
          <path
            id="Path_428"
            data-name="Path 428"
            d="M641.963,717.637a.817.817,0,0,1-1.635,0,.8.8,0,0,1,.824-.827A.785.785,0,0,1,641.963,717.637Zm-1.47,9.305v-7.264h1.319v7.264Z"
            transform="translate(-471.238 -716.122)"
            fill="#00668f"
          />
          <path
            id="Path_429"
            data-name="Path 429"
            d="M645.2,722.937c0-.931-.031-1.681-.06-2.372h1.186l.06,1.246h.029a2.854,2.854,0,0,1,2.581-1.412c1.756,0,3.078,1.487,3.078,3.692,0,2.613-1.591,3.9-3.3,3.9a2.549,2.549,0,0,1-2.236-1.14H646.5V730.8H645.2Zm1.305,1.936a2.828,2.828,0,0,0,.061.54,2.038,2.038,0,0,0,1.98,1.545c1.4,0,2.207-1.14,2.207-2.806,0-1.456-.766-2.7-2.161-2.7a2.107,2.107,0,0,0-2,1.637,2.16,2.16,0,0,0-.09.541Z"
            transform="translate(-472.427 -717.009)"
            fill="#00668f"
          />
          <path
            id="Path_430"
            data-name="Path 430"
            d="M656.547,722.937c0-.931-.032-1.681-.061-2.372h1.186l.059,1.246h.031a2.856,2.856,0,0,1,2.581-1.412c1.756,0,3.078,1.487,3.078,3.692,0,2.613-1.591,3.9-3.3,3.9a2.548,2.548,0,0,1-2.236-1.14h-.029V730.8h-1.305Zm1.305,1.936a2.9,2.9,0,0,0,.06.54,2.039,2.039,0,0,0,1.982,1.545c1.395,0,2.2-1.14,2.2-2.806,0-1.456-.764-2.7-2.161-2.7a2.107,2.107,0,0,0-2,1.637,2.16,2.16,0,0,0-.089.541Z"
            transform="translate(-475.234 -717.009)"
            fill="#00668f"
          />
          <path
            id="Path_431"
            data-name="Path 431"
            d="M669.334,717.637a.817.817,0,0,1-1.635,0,.8.8,0,0,1,.825-.827A.784.784,0,0,1,669.334,717.637Zm-1.47,9.305v-7.264h1.32v7.264Z"
            transform="translate(-478.007 -716.122)"
            fill="#00668f"
          />
          <path
            id="Path_432"
            data-name="Path 432"
            d="M672.566,722.532c0-.752-.014-1.366-.06-1.967h1.171l.074,1.2h.031a2.671,2.671,0,0,1,2.4-1.366c1.005,0,2.567.6,2.567,3.093v4.337h-1.322v-4.187c0-1.172-.434-2.147-1.681-2.147a1.879,1.879,0,0,0-1.771,1.351,1.931,1.931,0,0,0-.089.613v4.369h-1.32Z"
            transform="translate(-479.196 -717.009)"
            fill="#00668f"
          />
          <path
            id="Path_433"
            data-name="Path 433"
            d="M684.22,724.439a2.326,2.326,0,0,0,2.491,2.52,4.757,4.757,0,0,0,2.01-.376l.226.946a5.878,5.878,0,0,1-2.416.451,3.373,3.373,0,0,1-3.572-3.663c0-2.19,1.29-3.918,3.407-3.918,2.37,0,3,2.087,3,3.423a5.033,5.033,0,0,1-.044.616Zm3.872-.946a1.881,1.881,0,0,0-1.831-2.147,2.188,2.188,0,0,0-2.026,2.147Z"
            transform="translate(-481.781 -717.009)"
            fill="#00668f"
          />
          <path
            id="Path_434"
            data-name="Path 434"
            d="M693.3,726.479a3.467,3.467,0,0,0,1.742.526c.961,0,1.411-.48,1.411-1.082,0-.631-.376-.975-1.351-1.335-1.305-.465-1.921-1.186-1.921-2.056a2.241,2.241,0,0,1,2.506-2.132,3.63,3.63,0,0,1,1.788.452l-.332.961a2.827,2.827,0,0,0-1.485-.42c-.781,0-1.216.449-1.216.99,0,.6.435.871,1.38,1.23,1.261.48,1.907,1.111,1.907,2.193,0,1.276-.991,2.176-2.717,2.176a4.163,4.163,0,0,1-2.042-.5Z"
            transform="translate(-484.257 -717.009)"
            fill="#00668f"
          />
          <path
            id="Path_435"
            data-name="Path 435"
            d="M700.2,731.5a21.519,21.519,0,0,0,.9-3.587l1.472-.15a18.445,18.445,0,0,1-1.426,3.648Z"
            transform="translate(-486.043 -718.828)"
            fill="#00668f"
          />
          <path
            id="Path_436"
            data-name="Path 436"
            d="M711.06,716.833v10.115h-1.307V716.833Z"
            transform="translate(-488.406 -716.127)"
            fill="#00668f"
          />
          <path
            id="Path_437"
            data-name="Path 437"
            d="M714.642,722.532c0-.752-.017-1.366-.06-1.967h1.171l.075,1.2h.029a2.671,2.671,0,0,1,2.4-1.366c1,0,2.567.6,2.567,3.093v4.337H719.5v-4.187c0-1.172-.434-2.147-1.681-2.147a1.879,1.879,0,0,0-1.771,1.351,1.931,1.931,0,0,0-.09.613v4.369h-1.32Z"
            transform="translate(-489.601 -717.009)"
            fill="#00668f"
          />
          <path
            id="Path_438"
            data-name="Path 438"
            d="M730.74,727.565a4.863,4.863,0,0,1-2.086.42,3.452,3.452,0,0,1-3.617-3.707,3.692,3.692,0,0,1,3.9-3.858,4.423,4.423,0,0,1,1.832.376l-.3,1.021a3.061,3.061,0,0,0-1.53-.347,2.739,2.739,0,0,0-.046,5.465,3.745,3.745,0,0,0,1.622-.361Z"
            transform="translate(-492.186 -717.014)"
            fill="#00668f"
          />
          <path
            id="Path_439"
            data-name="Path 439"
            d="M734.055,728.923a.887.887,0,0,1,.9-.946.947.947,0,1,1-.9.946Z"
            transform="translate(-494.416 -718.883)"
            fill="#00668f"
          />
        </g>
      </g>
    </svg>
  )
}

export default TruckLogoMaintenaceIcon
